// Timezone formatting helpers producing "MM/DD/YYYY HH:MM" (no seconds, 24-hour)

export function formatUtcToTz(isoString, timeZone = 'America/New_York') {
	if (!isoString) return 'N/A';
	try {
		let source = isoString;
		if (typeof source === 'string' && source.length > 1 && source.startsWith('"') && source.endsWith('"')) {
			source = source.slice(1, -1);
		}
		const date = typeof source === 'string' || typeof source === 'number' ? new Date(source) : source;
		if (Number.isNaN(date.getTime())) return 'Invalid Date';
		const parts = new Intl.DateTimeFormat('en-US', {
			year: 'numeric', month: '2-digit', day: '2-digit',
			hour: '2-digit', minute: '2-digit', hour12: false,
			timeZone
		}).formatToParts(date);
		const lookup = Object.fromEntries(parts.map(p => [p.type, p.value]));
		// Ensure zero-padded values already provided by '2-digit'
		return `${lookup.month}/${lookup.day}/${lookup.year} ${lookup.hour}:${lookup.minute}`;
	} catch (e) {
		return 'Invalid Date';
	}
}

export function formatTimeOnlyUtcToTz(isoString, timeZone = 'America/New_York') {
	if (!isoString) return 'N/A';
	try {
		let source = isoString;
		if (typeof source === 'string' && source.length > 1 && source.startsWith('"') && source.endsWith('"')) {
			source = source.slice(1, -1);
		}
		const date = new Date(source);
		if (Number.isNaN(date.getTime())) return 'Invalid Date';
		const parts = new Intl.DateTimeFormat('en-US', {
			hour: '2-digit', minute: '2-digit', hour12: false, timeZone
		}).formatToParts(date);
		const lookup = Object.fromEntries(parts.map(p => [p.type, p.value]));
		return `${lookup.hour}:${lookup.minute}`;
	} catch {
		return 'Invalid Date';
	}
}


